module.exports = __webpack_public_path__ + "static/media/MARKET_PLACE.4514cd11.png";